import React from 'react';
import ReactDOM from 'react-dom';
import Modal from '../../components/Modal';
import grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import { doGoVote, getActiveCode } from '../../api';
import styles from './index.css';
import Toast from '../../components/Toast';
import Vote from './Vote';

/**
 * 投票通用方法
 * 1. 有票情况弹出投票弹窗
 * 2. 无票情况弹出无票弹窗
 * 3. ...
 *
 * @param {Object} p
 * @param {String} p.cateId 投票类别
 * @param {String} p.questionId 投票问题id
 * @param {String} p.itemId 投票项目id
 * @param {Number} p.voteNum 我的票数
 * @param {String} p.token
 *
 * */

export const goVote = ({ cateId, questionId, itemId, voteNum, token, cb }) => {
    let component = null;
    const lastEle = document.getElementById('goVoteDiv');

    if (lastEle) {
        lastEle.parentElement.removeChild(lastEle); // 删除上一次的弹窗
    }
    const div = document.createElement('div');

    div.setAttribute('id', 'goVoteDiv');
    document.body.appendChild(div);

    const handleCancel = () => {
        if (div) {
            ReactDOM.unmountComponentAtNode(div);
            if (div.parentElement) div.parentElement.removeChild(div);
        }
    };

    const toTV = () => {
        grounds.actionStat({ type: 'xdzlmtc_gkfhws' });
        grounds.gotoTabMenu('tabvideo', 'vch_phoenix');
    };

    const toMain = () => {
        grounds.actionStat({ type: 'xdzlmtc_ydgdjcnr' });
        grounds.gotoTabMenu('tabnews', 'sy');
    };

    const doGo = async num => {
        grounds.actionStat({ type: 'xdzlmtc_qrtp' });
        const res = await doGoVote({ token, cateId, questionId, itemId, num });
        const { code, data, msg } = res;

        if (code === 0) {
            if (data.Type4AddVote === 1) {
                Toast.success({
                    content: '已完成全部类型投票，投票次数+5',
                });
                handleCancel();
                cb(num);

                return;
            }
            Toast.success({
                content: '投票成功，感谢您的支持',
            });
            handleCancel();
            cb(num);
        } else {
            Toast.default({
                content: msg,
            });
        }
    };

    const toInvite = async () => {
        grounds.actionStat({ type: 'xdzlmtc_yqhyzl' });
        handleCancel();

        const res = await getActiveCode(token);

        if (res.code === 0) {
            const { invitecode } = res.data;

            grounds.openShare(
                `https://gongyi.ifeng.com/gysdVote?code=${invitecode}`,
                '【行动者联盟】2021公益盛典',
                '我已成为公益传播官，快为我助力吧~',
                'https://x0.ifengimg.com/ucms/2021_42/7B9C1F530CC9B3DF69734B4653C8E09B234E0FDC_size100_w326_h326.png',
                'id',
            );
        } else {
            Toast.default({ content: res.msg });
        }
    };

    if (voteNum > 0) {
        // eslint-disable-next-line react/jsx-filename-extension
        component = <Vote voteNum={voteNum} onClose={handleCancel} doGo={doGo} />;
    } else {
        component = (
            <Modal isOpen={true} onCancel={handleCancel}>
                <div className={styles.emptyContainer}>
                    <div className={styles.emptyTip}>您的票数余额已不足， 快去邀请好友获票吧！</div>
                    <div className={styles.emptyBtnWp}>
                        <div className={`${styles.emptyBtn} btn`} onClick={toInvite}>
                            邀请好友助力
                        </div>
                        <div className={`${styles.emptyBtn} btn`} onClick={toTV}>
                            观看凤凰卫视
                        </div>
                        {/* 客户端内凤凰卫视栏目 */}
                    </div>
                    <div className={styles.more} onClick={toMain}>
                        阅读更多精彩内容
                    </div>
                    {/* 客户端内头条流 */}
                </div>
            </Modal>
        );
    }

    ReactDOM.render(component, div);
};
